var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQ2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5783 15.9335C61.1293 23.9939 68.1019 33.3756 69.4962 44.0784C71.6668 60.7402 56.7665 68.8957 49.2167 61.5681C41.6668 54.2404 46.1925 44.9396 51.6593 42.3972C57.1262 39.8547 60.4693 40.7402 59.8862 37.3427C59.303 33.9454 51.5253 24.5257 44.6923 20.1389C44.239 19.7534 44.0665 19.0054 44.503 18.4379C44.7902 18.0647 45.3533 17.3328 46.1925 16.2421C46.9263 15.2883 47.6293 15.324 48.5783 15.9335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5354 15.9335C28.0863 23.9939 35.0589 33.3756 36.4533 44.0784C38.6238 60.7402 23.7234 68.8957 16.1736 61.5681C8.62377 54.2404 13.1494 44.9396 18.6163 42.3972C24.0831 39.8547 27.4264 40.7402 26.8431 37.3427C26.2599 33.9454 18.4823 24.5257 11.6493 20.1389C11.1959 19.7534 11.0234 19.0054 11.4601 18.4379C11.7471 18.0647 12.3103 17.3328 13.1494 16.2421C13.8833 15.2883 14.5863 15.324 15.5354 15.9335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ2);
export default __webpack_public_path__ + "static/media/q2.3448b53bb7e66d63b3a2bd4e322776d6.svg";
export { ForwardRef as ReactComponent };